import fb from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/functions';

export const firebaseConfig = {
    apiKey: "AIzaSyBsZIeMGM3OT6BZ4zayMpX3K6AYgXrotvs",
    authDomain: "urb-mobilidade.firebaseapp.com",
    databaseURL: "https://urb-mobilidade.firebaseio.com",
    projectId: "urb-mobilidade",
    storageBucket: "urb-mobilidade.appspot.com",
    messagingSenderId: "95310250597",
    appId: "1:95310250597:web:3c1af5073fcceb46347c8c",
    measurementId: "G-2T15P41M6D"
};

export let firebase = fb;

export let app = fb.initializeApp(firebaseConfig);

export let db = app.database();

export let auth = app.auth();

export let functions = app.functions();